import { FundOfferBaseEntity } from '@genial/services';
import { ResponsesFundOfferCategoriesResponse } from '@genial/services/dist/models';
import { atom } from 'recoil';

import { applicationRangeDefault, daysRangeDefault } from '../../../pages/NewApplication/Filter';
import { fundOperationTypeInitialTab, pagination, sortItemsFund } from '../constants';
import {
  FundOfferByFilterParams,
  FundsOffersBySearchTerm,
  type FundRedemptionOfferNormalized,
  type FundRedemptionsOffersBySearchTerm,
} from '../types';

export const fundOffersAllState = atom({
  key: 'fundOffersAllState',
  default: [] as FundOfferBaseEntity[],
});

export const fundOffersByFilterParamsState = atom({
  key: 'fundOffersByFilterParamsState',
  default: {
    ...pagination,
    sortItems: sortItemsFund,
    maximumRedemptionDays: daysRangeDefault.max,
    minimumRedemptionDays: daysRangeDefault.min,
    applicationMinimumAmount: applicationRangeDefault.min,
    applicationMaximumAmount: applicationRangeDefault.max,
  } as FundOfferByFilterParams,
});

export const fundOffersBySearchTermState = atom({
  key: 'fundOffersBySearchTermState',
  default: [] as FundOfferBaseEntity[],
});

export const fundOffersBySearchTermParamsState = atom({
  key: 'fundOffersBySearchTermParamsState',
  default: {
    ...pagination,
    skipEndpointCall: true,
    sortItems: sortItemsFund,
  } as FundsOffersBySearchTerm,
});

export const fundCategoriesFilterState = atom({
  key: 'fundCategoriesFilterState',
  default: { data: [] as ResponsesFundOfferCategoriesResponse[] },
});

export const fundOffersOperationTypeState = atom({
  key: 'fundOffersOperationTypeState',
  default: fundOperationTypeInitialTab,
});

export const fundRedemptionsOffersAllState = atom({
  key: 'fundRedemptionsOffersAllState',
  default: [] as FundRedemptionOfferNormalized[],
});

export const fundRedemptionsOffersBySearchTermParamsState = atom({
  key: 'fundRedemptionsOffersBySearchTermParamsState',
  default: {
    skipEndpointCall: true,
  } as FundRedemptionsOffersBySearchTerm,
});

export const fundRedemptionsOffersBySearchTermState = atom({
  key: 'fundRedemptionsOffersBySearchTermState',
  default: [] as FundRedemptionOfferNormalized[],
});
